'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../../../libs/colors');

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _UploaderContainer = require('./UploaderContainer.FileManager');

var _UploaderContainer2 = _interopRequireDefault(_UploaderContainer);

var _UploadContent = require('./UploadContent.FileManager');

var _UploadContent2 = _interopRequireDefault(_UploadContent);

var _Indicator = require('./Indicator.FileManager');

var _Indicator2 = _interopRequireDefault(_Indicator);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Colors
// Components
// Styles


var styles = {
  default: {
    width: '100%',
    height: '100%',
    borderStyle: 'dashed',
    borderWidth: '2px',
    borderColor: _colors.grey,
    borderRadius: '5px',
    overflow: 'hidden',
    color: _colors.darkGrey,
    cursor: 'pointer',
    WebkitUserSelect: 'none',
    userSelect: 'none',
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  active: {
    background: _colors.white
  },
  accept: {
    background: _colors.white,
    borderColor: _colors.green,
    color: _colors.green
  },
  reject: {
    background: _colors.white,
    borderColor: _colors.red,
    color: _colors.red
  }
};

var Uploader = function (_Component) {
  _inherits(Uploader, _Component);

  function Uploader() {
    _classCallCheck(this, Uploader);

    return _possibleConstructorReturn(this, (Uploader.__proto__ || Object.getPrototypeOf(Uploader)).apply(this, arguments));
  }

  _createClass(Uploader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          accept = _props.accept,
          multiple = _props.multiple,
          onChange = _props.onChange,
          small = _props.small,
          loading = _props.loading;
      return _react2.default.createElement(_UploaderContainer2.default, null, _react2.default.createElement(_reactDropzone2.default, {
        onDrop: onChange,
        accept: accept,
        multiple: multiple,
        style: styles.default,
        activeStyle: styles.active,
        acceptStyle: styles.accept,
        rejectStyle: styles.reject
      }, _react2.default.createElement(_UploadContent2.default, {
        small: small
      })), _react2.default.createElement(_Indicator2.default, {
        visible: loading
      }));
    }
  }]);

  return Uploader;
}(_react.Component);

Uploader.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  accept: _propTypes2.default.string,
  small: _propTypes2.default.bool,
  loading: _propTypes2.default.bool
};
Uploader.defaultProps = {
  accept: 'application/pdf, image/*',
  multiple: false,
  small: false,
  loading: false
};
exports.default = Uploader;